"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _green = _interopRequireDefault(require("../tokens/color/green"));
var _Cross = _interopRequireDefault(require("../Icons/all/Cross"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _commonHelper = require("../helpers/commonHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Textfield = function Textfield(_ref) {
  var placeholder = _ref.placeholder,
    searchStr = _ref.searchStr,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove,
    value = _ref.value,
    isMenuOpen = _ref.isMenuOpen,
    tags = _ref.tags,
    type = _ref.type,
    setInputRef = _ref.setInputRef,
    placeholderFont = _ref.placeholderFont,
    maxLength = _ref.maxLength;
  var node = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (tags.length && isMenuOpen) placeCursor();
  });
  (0, _react.useEffect)(function () {
    if (node.current) setInputRef(node);
  }, [setInputRef]);
  var placeCursor = function placeCursor() {
    return node.current.focus();
  };
  var getWidth = function getWidth() {
    return (searchStr.length + 1) * 12 + "px";
  };
  var removeItem = function removeItem(item) {
    return function () {
      return onRemove(item);
    };
  };
  var showTags = function showTags(tags) {
    return tags.map(function (t) {
      return /*#__PURE__*/_react["default"].createElement(TagSpan, {
        key: t.value,
        background: getBackground(type),
        color: getColor(type)
      }, /*#__PURE__*/_react["default"].createElement(Span, null, t.label), /*#__PURE__*/_react["default"].createElement(_Cross["default"], {
        showPointer: true,
        color: getColor(type),
        onClick: removeItem(t.value),
        onKeyUp: (0, _commonHelper.onKeySelect)(removeItem(t.value)),
        tabIndex: "0"
      }));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(Textfield.Wrapper, {
    onClick: placeCursor,
    hasTag: !!tags.length,
    className: "Wrapper"
  }, !searchStr && !tags.length && /*#__PURE__*/_react["default"].createElement(Textfield.Placeholder, {
    onClick: placeCursor,
    placeholderFont: placeholderFont
  }, placeholder), showTags(tags), /*#__PURE__*/_react["default"].createElement(Textfield.Input, {
    tabIndex: "0",
    ref: node,
    value: value,
    onChange: onChange,
    hasTag: !!tags.length,
    hasSearchStr: !!searchStr,
    setWidth: getWidth,
    maxLength: maxLength
  }));
};
var getColor = function getColor(type) {
  return colors[type || "default"] || _black["default"];
};
var getBackground = function getBackground(type) {
  return backgrounds[type || "default"] || _grey["default"].z200;
};
var colors = {
  "default": _black["default"],
  red: _white["default"],
  green: _white["default"]
};
var backgrounds = {
  "default": _grey["default"].z200,
  red: _red["default"].z500,
  green: _green["default"].z500
};
var Span = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-jn9fbm-0"
})(["margin-right:1rem;margin-top:0.2rem;font-size:1.8rem;font-weight:300;"]);
var TagSpan = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-jn9fbm-1"
})(["position:relative;display:inline-flex;float:left;padding:0.95rem 0.9rem 1rem 1rem;background:", ";color:", ";border-radius:", ";margin:0.5rem 0.6rem 0 0;"], function (props) {
  return props.background;
}, function (props) {
  return props.color;
}, _misc["default"].radius);
Textfield.propTypes = {
  searchStr: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onRemove: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  isMenuOpen: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  tags: _propTypes["default"].array,
  type: _propTypes["default"].oneOf(["default", "red", "green"]),
  setInputRef: _propTypes["default"].func,
  placeholderFont: _propTypes["default"].string,
  maxLength: _propTypes["default"].string
};
Textfield.defaultProps = {
  placeholder: "",
  searchStr: "",
  onChange: _noop2["default"],
  onRemove: _noop2["default"],
  value: "",
  isMenuOpen: false,
  tags: [],
  type: "default",
  setInputRef: _noop2["default"],
  placeholderFont: "1.8rem",
  maxLength: ""
};
Textfield.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-jn9fbm-2"
})(["position:relative;margin-bottom:", ";overflow:auto;padding:", ";"], function (props) {
  return props.hasTag ? "0.5rem" : "0";
}, function (props) {
  return props.hasTag ? "0" : "0.1rem 0";
});
Textfield.Placeholder = _styledComponents["default"].div.withConfig({
  componentId: "sc-jn9fbm-3"
})(["position:absolute;cursor:text;color:", ";font-weight:300;font-size:", ";margin-top:0.2rem;width:max-content;"], _grey["default"].z400, function (props) {
  return props.placeholderFont;
});
Textfield.Input = _styledComponents["default"].input.withConfig({
  componentId: "sc-jn9fbm-4"
})(["color:", ";width:", ";overflow:hidden;text-overflow:ellipsis;outline:none;height:", ";border:none;font-family:inherit;margin-top:", ";font-size:18px;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box;", ""], _black["default"], function (props) {
  return props.hasSearchStr ? props.setWidth : "1rem";
}, function (props) {
  return props.hasTag ? "4.2rem" : "100%";
}, function (props) {
  return props.hasTag ? "0.6rem" : "0";
}, function (props) {
  return props.hasTag && (0, _styledComponents.css)(["float:left;"]);
});
var _default = exports["default"] = Textfield;